import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// --- Firebase Service Worker Kaydı ---
// Bu blok, public klasöründeki firebase-messaging-sw.js dosyasını tarayıcıya kaydeder.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('Service Worker başarıyla kaydedildi. Kapsam:', registration.scope);
      })
      .catch((err) => {
        console.error('Service Worker kaydı sırasında hata oluştu:', err);
      });
  });
}